import classNames from 'classnames'
import React from 'react'

import { Bar } from './Bar'
import styles from './Progress.module.scss'

export * from './Bar'

interface ProgressProps {
  finish: number
  inProgress: number
  pending: number
  className?: string
  classes?: {
    bar?: string
    pending?: string
    inProgress?: string
    finish?: string
  }
}

export const Progress: React.FC<ProgressProps> = ({
  finish,
  inProgress,
  pending,
  className,
  classes,
}) => {
  const total = finish + inProgress + pending
  return (
    <div className={classNames(styles.progressBar, className)}>
      <Bar
        style={{ width: finish + '%' }}
        className={classNames(classes?.bar, classes?.finish || styles.finish)}
      />
      <Bar
        style={{ width: inProgress + '%' }}
        className={classNames(
          classes?.bar,
          classes?.inProgress || styles.inProgress
        )}
      />
      <Bar
        style={{ width: ((!total && 100) || pending) + '%' }}
        className={classNames(classes?.bar, classes?.pending || styles.pending)}
      />
    </div>
  )
}

export default Progress
